"use strict";
/*---------------------------------------------------------------------------------------------
*  Licensed to the .NET Foundation under one or more agreements.
*  The .NET Foundation licenses this file to you under the MIT license.
*--------------------------------------------------------------------------------------------*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.IVSCodeEnvironment = void 0;
class IVSCodeEnvironment {
}
exports.IVSCodeEnvironment = IVSCodeEnvironment;
//# sourceMappingURL=IVSCodeEnvironment.js.map